// Module
var code = "<div class=\"history-field-signature\"> <div class=\"no-value-text\" ng-if=\"$ctrl.noValueText\">{{$ctrl.formValue}}</div> <img ng-if=\"!$ctrl.noValueText\" ng-src=\"{{$ctrl.formValue}}\"/> <p ng-if=\"!$ctrl.noValueText\">{{$ctrl.signedAtMessage}}</p> </div> ";
// Exports
export default code;